import React from 'react'
import { Link } from "react-router-dom"

import { useListData } from '../../modules'

import Modal from "../resusable/modal"

const SelectStation = ({ toggle, visible }) => {
    const [, { list: serviceStations = [] }] = useListData('dispensingStations', null, { notify: true }, 'stations')
    
    return (
        <Modal
            title="Select Station"
            w="w-2/3 xl:w-1/2"
            h=""
            top="mt-10"
            toggle={ toggle }
            visible={ visible }>
            <div className="max-w-7xl mx-auto px-4 lg:px-6 py-1">
                {
                    serviceStations.length > 0 ?
                        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-4 py-8">
                            {
                                serviceStations.map(station =>
                                    <Link to={ `/app/bills/${station._id}/new` }>
                                        <div className="p-6 col-span-1 md:col-span-2 lg:col-span-1 bg-white flex items-center space-x-6 rounded-lg shadow-md hover:scale-105 transition transform duration-500 cursor-pointer">
                                            <div>
                                                <h1 className="text-xl font-bold text-gray-700 mb-2">{ station.name }</h1>
                                                <p className="text-gray-600 w-80 text-sm">{ station.major }</p>
                                            </div>
                                        </div>
                                    </Link>
                                )
                            }
                        </div>
                    : 
                        <div className="flex font-bold text-xl justify-center items-center">
                            <h2>No stations have been added yet</h2>
                        </div>
                }
            </div>            
        </Modal>
    )
}

export default SelectStation